/**
 * Barrel do módulo Orçamento.
 *
 * `DashboardOrcamento` (`2i`) entra por `lazy` pelo mesmo motivo das duas telas
 * de gráfico do FinOps: o Recharts é a maior peça do bundle, e ninguém aterrissa
 * primeiro no dashboard orçamentário — o caminho é login → seletor de cliente →
 * uma aba. As outras duas abas não têm gráfico e entram no chunk normal.
 */
import { lazy } from 'react'

export const DashboardOrcamento = lazy(() =>
  import('./telas/DashboardOrcamento').then((m) => ({ default: m.DashboardOrcamento })),
)

export { Contratos } from './telas/Contratos'
export { Faturas } from './telas/Faturas'
